module.exports = __webpack_public_path__ + "public/Icons/breakIcon.svg?29780e4c";